export default __webpack_public_path__ + "static/media/Lapis.868b19bd.jpg";